import { useState, useEffect } from 'react';
import { ENDPOINTS } from '../api/api';

export function useAppsByGrade(grade) {
  const [apps, setApps]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const url = grade === 'All' ? ENDPOINTS.apps : ENDPOINTS.appsByGrade(grade);
    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        setApps(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => {
        setApps([]);
        setLoading(false);
      });
  }, [grade]);

  return { apps, loading };
}
